var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdobeAi = function SvgAdobeAi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e10ebf18-09a3-4cbe-9967-4d9c1590f790",
    "data-name": "aecc1f94-190e-43b7-9567-02347d9abefb",
    viewBox: "0 0 495 482.8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M418.2,482.7H76.8c-.5-1-1.4-.8-2.3-1A71.8,71.8,0,0,1,59.3,478C26.7,465.7,7.1,442.4,1,408c-.1-.8-.1-1.6-1-2V76.8c1-.5.9-1.4,1-2.3a78,78,0,0,1,3.6-15C17,26.8,40.2,7.1,74.8,1c.8-.2,1.6-.1,2-1H418.7c.8,1.4,2.4,1,3.6,1.3a85.7,85.7,0,0,1,48.4,25.9A86.2,86.2,0,0,1,494,74.8c.1.8.1,1.6,1,2V406c-1,.4-.9,1.4-1,2.2a81.2,81.2,0,0,1-3.7,15.3c-12.4,32.6-35.6,52.2-70.1,58.3C419.5,481.9,418.6,481.9,418.2,482.7Z",
    transform: "translate(0 0)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.3,289.7H165.5c-2,0-2.6.7-3.1,2.4-4.8,15-9.7,30-14.5,45-1.2,3.6-1.8,4-5.6,4h-36c-4.1,0-4.7-.9-3.4-4.8,8.9-25.8,17.9-51.5,26.8-77.3l38.7-111.4a59.9,59.9,0,0,0,3.8-20.9c0-2.3,1-3,3.1-3h51.1c2.2,0,3.3.8,4.1,3q36.9,104.7,74.1,209.3l.6,1.8c.6,2.5,0,3.3-2.6,3.4H260.5c-2.5,0-3.4-1.4-4.1-3.4-5.2-15.3-10.5-30.5-15.7-45.8-.6-1.7-1.3-2.3-3.1-2.3ZM201,161.4c-7.3,29.6-17.1,57.6-25.5,86.2h52C218.5,219,209,190.8,201,161.4Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fd9900"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.1,258.3V180.9c0-4.5.2-4.7,4.8-4.7h37.5c3.3,0,4,.6,4,4V337c0,3.7-.7,4.2-4.5,4.2H332.2c-4.6,0-5-.5-5-5Q327.1,297.4,327.1,258.3Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fd9900"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.5,158.8c-14.6.4-26.4-10.7-25.6-27.7a25.3,25.3,0,0,1,26.2-24c15.7.4,25.4,10.8,25.1,26.7S365,159.1,350.5,158.8Z",
    transform: "translate(0 0)",
    style: {
      fill: "#fd9900"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdobeAi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adobe-ai.b0df5154.svg";
export { ForwardRef as ReactComponent };